import { render } from "./AgentMenuTab.vue?vue&type=template&id=6fe92da5"
import script from "./AgentMenuTab.vue?vue&type=script&lang=js"
export * from "./AgentMenuTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__